import GenericTopPostsDrawer from './GenericTopPostsDrawer';
import { getHashtagTopPosts } from 'utils/api/instagram.api';

const HashtagTopPostsDrawer = ({
    year,
    week,
    hashtags,
    countries,
    name,
    displayQty,
}) => {
    const queryParams = {
        hashtag: hashtags || null,
        country: countries || null,
        page: 1,
        per_page: 500,
    };

    return (
        <GenericTopPostsDrawer
            year={year}
            week={week}
            name={name}
            displayQty={displayQty}
            queryFn={getHashtagTopPosts}
            queryParams={queryParams}
        />
    );
};

export default HashtagTopPostsDrawer;
